import React from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const PieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    // Route::get('{scope}/aggregated/{collection}/{field}', [StatisticsViewController::class, 'getDataAggregatedByField']);
    // getDataAggregatedByField(Request $request, $scope, $collection, $field)

    //Route::get('{scope}/aggregatedsum/{collection}/{aggregationfield}/{sumfield}', [StatisticsViewController::class, 'getDataSumAggregatedByField']);
    return (drawable &&
        <>
            <Box className="report-itemgroup">
                <Box className="report-itemrow">
                    <Box className="report-item">
                        <Pie
                            title={t("Budget Locale per Area")}
                            dataProviderName={"statisticsviews/budgetperareal/aggregatedsum/views_commercials_areasource/_related_area_name/budgetLocale"}
                            filters={filterModel}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                        />
                    </Box>
                    <Box className="report-item">
                        <Pie
                            title={t("Eroso per Area")}
                            dataProviderName={"statisticsviews/budgetperareale/aggregatedsum/views_commercials_areasource/_related_area_name/budgetLocaleErodedStatic"}
                            filters={filterModel}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                        />
                    </Box>
                    <Box className="report-item">
                        <Pie
                            title={t("Rimanente per Area")}
                            dataProviderName={"statisticsviews/budgetperarealr/aggregatedsum/views_commercials_areasource/_related_area_name/budgetLocaleRemainingStatic"}
                            filters={filterModel}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                        />
                    </Box>
                </Box>
                  <Box className="report-itemrow">
                    <Box className="report-item">
                        <Pie
                            title={t("Budget Locale per Sorgente")}
                            dataProviderName={"statisticsviews/budgetpersourcel/aggregatedsum/views_commercials_areasource/_related_source_name/budgetLocale"}
                            filters={filterModel}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                        />
                    </Box>
                    <Box className="report-item">
                        <Pie
                            title={t("Eroso per Sorgente")}
                            dataProviderName={"statisticsviews/budgetpersourcele/aggregatedsum/views_commercials_areasource/_related_source_name/budgetLocaleErodedStatic"}
                            filters={filterModel}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                        />
                    </Box>
                    <Box className="report-item">
                        <Pie
                            title={t("Rimanente per Sorgente")}
                            dataProviderName={"statisticsviews/budgetpersourcelr/aggregatedsum/views_commercials_areasource/_related_source_name/budgetLocaleRemainingStatic"}
                            filters={filterModel}
                            showTotal={false}
                            handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default PieSet;